export default __webpack_public_path__ + "static/media/header_3.2e7d6374.jpg";